module.exports = __webpack_public_path__ + "system/img/none-006.fa8bea7d.png";